import React from "react";
import styled from "styled-components";
import LeagueLinksDropdown from "./LeagueLinksDropdown";
import SeasonLinksDropdown from "./SeasonLinksDropdown";
import WeekLinksDropdown from "./WeekLinksDropdown";

const StyledLeagueInfoUl = styled.ul`
  display: flex;
  flex-flow: column;
  margin: 0;
  padding: 0;
  list-style-type: none;

  & > li:first-child {
    width: 100%;
  }

  & > li {
    padding-left: 0.25rem;
  }
`;

const NavSideLeagueInfo = () => {
  return (
    <StyledLeagueInfoUl>
      <li>
        <LeagueLinksDropdown />
      </li>
      <li>
        <SeasonLinksDropdown />
      </li>
      <li>
        <WeekLinksDropdown />
      </li>
    </StyledLeagueInfoUl>
  );
};

export default NavSideLeagueInfo;
